export enum AccommodationTravelStatus {
  NotRequired = "NotRequired", // not use it, deprecated by CRMDEV-2498
  Required = "Required", // not use it, deprecated by CRMDEV-2498
  ApprovedManually = "ApprovedManually", // not use it, deprecated by CRMDEV-2498
  Blank = "Blank",
  Requested = "Requested",
  Confirmed = "Confirmed"
}
